import { template } from 'underscore';
import { isEmpty } from 'underscore';
import Backbone from 'backbone';
import TemplateModel from '../model/template';
import data from '../config/templateIcons.js';
var commonFunction = require('../../common/common');
var sourceFile = require('../../../config/config.js');
const url = sourceFile.url;
const rootDir = sourceFile.rootDir;

export default Backbone.View.extend({
  initialize(o) {
    this.icons = data.templateIcons;
    this.iconFolder = data.iconFOLDER;
    this.defaulticon = data.defaulticon;
    this.rootDir = rootDir;
    let templateData = this.formatData(o.modelData.template);
    let groupsData = this.formatData(o.modelData.groups);
    this.groupsData = isEmpty(groupsData) ? [] : groupsData[0].data;
    this.model = new TemplateModel();
    if (!isEmpty(templateData)) {
      this.isNewTemplate = false;
      this.model.set(templateData[0]);
    } else {
      this.isNewTemplate = true;
    }
    this.render();
  },

  $templateName: '.template-details.template-name input',
  $keywords: '.template-details.template-tags input',
  $groupID: '.template-details.template-group select',
  $imageUrl: '.template-details-card .template_thumbnail img',
  $uploadLoader: '.template-details-card .template_thumbnail .image_loader',
  $description: '.template-details.template-descrption textarea',
  $update: '.template-button.template-agree.update',
  $add: '.template-button.template-agree.add',
  $active: '.template-details.template-active .switch',

  events: {
    'click .image-upload-holder .drop_zone': 'openFilePicker',
    'click .template-cancel': 'closeModal',
    'click .close-icon': 'closeModal',
    'click .template-button.template-agree.add': 'addToMarketPlaceTemplate',
    'click .template-button.template-agree.update': 'updateMarketplaceTemplate',
    'change .add_template_file_upload': 'uploadImage'
  },

  template: template(
    `<div class="template-details-card">
        
        <div class="left-side">
            <div class="header-text">Upload an icon/image</div>
            <div class="image-upload-holder">                
                <input type="file" class="add_template_file_upload" accept="image/x-png,image/gif,image/jpeg" style="display:none;">                
                <div class="right-side-text drop_zone">
                    Drop your icon here, or
                    <span> Browse </span>
                </div>
            </div>
            <div class="template_thumbnail">
                <div class="image_loader hide">
                    <div class="loader"></div>
                </div>
                <img src="<%= this.defaulticon %>">
            </div>
            <div class="icon-picker hide">
                <div class="header">Or select an icon</div>
                <div class="icon-holder"> 
                    <% _.each(this.icons, function(icon){ %>
                    <div class="icon"><img src="<%= _.escape(this) %><%= _.escape(icon.url) %>"></div>
                    <% },[this.iconFolder]); %>
                </div>
            </div>
        </div>
        <div class="right-side">
            <div class="header">
                <div class="templateicon-view">
                    <img class="hide" src="<%= this.defaulticon %>">
                </div>
                <div class="close-icon">
                    <img src="<%= this.rootDir%>/assets/images/close.svg">
                </div>
            </div>
            <div class="template-details-body">
                <div class="template-details template-name">
                    <input type="text" placeholder="Template name">
                </div>
                <div class="template-details template-descrption">
                    <textarea placeholder="Description" rows="2" resize="no"></textarea>
                </div>
                <div class="template-details template-tags">

                    <input placeholder="Keywords" type="text">
                </div>
                <div class="template-details two-column">
                    <div class="template-details template-group">
                        <select name="two" class="dropdown-select">
                            <option value="">Group</option>
                            <% _.each(this.groupsData, function(group){ %>
                                <option value="<%= group.id %>"><%= group.name %></option>
                            <% })%>
                        </select>

                    </div>
                    <div class="template-details template-active hide">
                        <label>Active</label>
                        <input type="checkbox" class="switch">
                    </div>
                </div>
            </div>

            <div class="template-actions">
                <div class="template-button template-cancel">Cancel</div>
                <div class="template-button template-agree add">Add</div>
                <div class="template-button template-agree update hide">Update</div>
            </div>
        </div>
    </div>`
  ),

  // event handler functions//

  openFilePicker(e) {
    $('.add_template_file_upload').trigger('click');
  },

  closeModal(e) {
    this.$el.remove();
  },

  addToMarketPlaceTemplate(e) {
    this.submitButtonClicked('addNewDesignerTemplate');
  },

  updateMarketplaceTemplate(e) {
    this.submitButtonClicked('updateDesignerTemplate');
  },

  uploadImage(e) {
    var fileData = e.target.files && e.target.files[0];
    this.uploadImagetoS3(fileData);
  },

  // end //

  // helper funcitons //

  createTags(keywords) {},

  formatData(data) {
    if (!isEmpty(data)) {
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
    }
    return data;
  },

  prefilltheValues: function(data) {
    this.$el.find(this.$templateName).val(data.name);
    this.$el.find(this.$keywords).val(data.keywords);
    this.$el.find(this.$groupID).val(data.group);
    this.$el.find(this.$description).val(data.description);
    this.$el.find(this.$imageUrl).prop('src', data.image);
    this.$el
      .find(this.$active)
      .prop('checked', data.is_active)
      .parent()
      .removeClass('hide');
    this.$el.find(this.$update).removeClass('hide');
    this.$el.find(this.$add).addClass('hide');
  },

  bindDragEvents() {
    let dropArea = this.$el.find('.drop_zone')[0];
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      dropArea.addEventListener(eventName, preventDefaults, false);
    });
    dropArea.addEventListener('drop', handleDrop.bind(this), false);

    function handleDrop(e) {
      let dt = e.dataTransfer;
      let files = dt.files;
      this.uploadImagetoS3(files[0]);
    }

    function preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },

  uploadImagetoS3(fileData) {
    this.$el.find(this.$uploadLoader).removeClass('hide');
    this.$el.addClass('disable');
    if (fileData) {
      var formData = new FormData();
      if (fileData instanceof Blob) {
        var extension = fileData.type.split('/')[1];
        formData.append(
          'blob',
          fileData,
          'api_' + new Date().getTime() + '.' + extension
        );
      } else {
        formData.append('file', fileData);
      }
      formData.append('dhqOperation', 'sessionImageUpload');

      function success(data) {
        if (typeof data === 'string') {
          data = JSON.parse(data);
        }
        this.$el.find(this.$imageUrl).prop('src', data.image_url);
        this.$el.find(this.$uploadLoader).addClass('hide');
        this.$el.removeClass('disable');
      }

      $.ajax({
        type: 'POST',
        url: url + 'Handler/FormBuilderResponseHandler.ashx',
        data: formData,
        success: success.bind(this),
        error: function(err) {
          this.$el.find(this.$uploadLoader).addClass('hide');
          this.$el.removeClass('disable');
          console.log(err);
        }.bind(this),
        processData: false,
        contentType: false
      });
    }
  },

  showErrors(errors) {
    this.hideErrors();
    errors.forEach(function(error) {
      switch (error.name) {
        case 'name':
          this.$el
            .find('.template-details.template-name')
            .css('border-color', 'red');
          break;
        case 'description':
          this.$el
            .find('.template-details.template-descrption')
            .css('border-color', 'red');
          break;
        case 'keywords':
          this.$el
            .find('.template-details.template-tags')
            .css('border-color', 'red');
          break;
        case 'group':
          this.$el
            .find('.template-details.template-group')
            .css('border-color', 'red');
          break;
        case 'image':
          this.$el.find(this.$imageUrl).css('border', '1px solid red');
          break;
      }
    }, this);
  },

  hideErrors() {
    this.$el.find('.template-details.template-name').removeAttr('style');
    this.$el.find('.template-details.template-descrption').removeAttr('style');
    this.$el.find('.template-details.template-tags').removeAttr('style');
    this.$el.find('.template-details.template-group').removeAttr('style');
  },

  // end //

  submitButtonClicked: function(operation) {
    //fetch user input data.
    let templateName = this.$el.find(this.$templateName).val();
    let keywords = this.$el.find(this.$keywords).val();
    let groupID = this.$el.find(this.$groupID).val();
    let imageUrl = this.$el.find(this.$imageUrl).prop('src');
    let isActive = this.$el.find(this.$active).prop('checked') ? 1 : 0;
    let description = this.$el.find(this.$description).val();
    let control_id = $('.is-component-selected').data('control_id');

    var template = {
      name: templateName,
      control_id: control_id,
      keywords: keywords,
      group: groupID,
      image: imageUrl,
      description: description,
      is_active: isActive,
      html: editor.getHtml(),
      css: editor.getCss(),
      js: ''
    };
    let errors = this.model.validate(template);
    if (errors) {
      this.showErrors(errors);
    } else {
      this.model.set(template);
      var payload = this.model.toJSON();
      payload['operation'] = operation;

      commonFunction.fnAjaxRequest(
        url + 'Handler/DesignerTemplateHandler.ashx',
        'POST',
        payload,
        this.onSuccess.bind(this),
        this.onError.bind(this)
      );
    }
  },

  onSuccess: function(data) {
    commonFunction.ShowVSAlert('success', 'Operation Completed Successfully.');
    this.closeModal();
    console.log('success :', data);
  },

  onError: function(error) {
    console.log('error :', error);
  },

  render() {
    this.$el.append(this.template());
    if (!this.isNewTemplate) {
      this.prefilltheValues(this.model.toJSON());
    }
    this.bindDragEvents();
  }
});
